export default __webpack_public_path__ + "static/media/home_banner.d0107965.png";